import { cva, type VariantProps } from 'class-variance-authority';

/**
 * ExpertBox variant styles using Class Variance Authority (CVA).
 * All styles use design tokens from the HEN Design System.
 *
 * ## Variants
 * - default: Light gray background (bg-neutral-50)
 * - plain: No background
 */
export const expertBoxVariants = cva('rounded-md py-5 px-6', {
  variants: {
    variant: {
      default: 'bg-neutral-50',
      plain: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ExpertBoxVariantProps = VariantProps<typeof expertBoxVariants>;
